module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page static-pwd-page",
    attrs: {
      "data-animsition-in": "fade-in",
      "data-animsition-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-brand-info"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "font-size-20"
  }, [_vm._v(_vm._s(_vm.$t('login.desc_long')))])]), _vm._v(" "), _c('div', {
    staticClass: "page-login-main"
  }, [_vm._m(1), _vm._v(" "), _c('h3', {
    staticClass: "font-size-30 font-size-24"
  }, [_vm._v(_vm._s(_vm.$t('login.title')))]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginStaticPwd(_vm.user)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-material floating",
    attrs: {
      "data-plugin": "formMaterial"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control empty",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "name": "password",
      "placeholder": _vm.$t('input.password')
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "floating-label",
    attrs: {
      "for": "inputPassword"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn_block_save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.connect')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "static/material/iconbar/assets/images/superhote__logo.svg",
      "alt": "super-manager-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand hidden-md-up"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "static/material/iconbar/assets/images/superhote__logo.svg",
      "alt": "super-manager-logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194c6fc4"}!./src/app/pages/static-pwd/index/index.html
// module id = 1308
// module chunks = 0